// extracted by css-extract-rspack-plugin
export default {"overlay":"b8zsRlnPE0engbjB","container":"HxXYBLJi1VYrPHbT","icon":"GheH9JxpmA0yfM6N","textContainer":"P3R_HddcmMcJd2Av","title":"j0ZkryIdZSkWzCny","subtitle":"ruPl7_17EoAsoH71"};